import { useCollectionItems } from 'marketplace-ui-common/collections/hooks/useCollectionItems';
import { GET_APP_COLLECTION_ITEMS } from '../queries/appCollectionItemsQuery';
export function useAppCollectionItems({
  appContext,
  collectionId,
  language,
  length,
  offset
}) {
  return useCollectionItems(GET_APP_COLLECTION_ITEMS, 'appCollectionItems', {
    appContext,
    collectionId,
    language,
    length,
    offset
  });
}